import { OloOrderHistorySource } from './olo_order_history_source.js';

export function name(source: OloOrderHistorySource): string {
  switch (source) {
    case OloOrderHistorySource.RecentProducts:
      return 'Recent Products';
    case OloOrderHistorySource.RecentOrders:
      return 'Recent Orders';
  }
}
